export default "__VITE_ASSET__B7Wf5fp7__"